// extracted by mini-css-extract-plugin
export default {"article":"simple-article_article__qrTUZ","bigMarginStyle":"simple-article_bigMarginStyle__gYKQU"};